import React, { useState } from 'react'
import {
  ImagePreviewWrapper,
  ImagePreviewWrapperSizeEnum,
} from 'UiKitComponents/ImagePreviewWrapper/ImagePreviewWrapper'
import { IBuffetGeneralReportResult } from 'core/api/dto/BuffetGeneralReportDto'
import { AppTableMobile } from 'components/AppTable/AppTableMobile'
import { ReportTempView } from 'pages/BuffetLinePage/ReportPage/ReportPage'
import { SetURLSearchParams } from 'react-router-dom'
import { SubTableRepresentTemperature } from './SubTableRepresentTemperature'
import { useTranslation } from 'react-i18next'
import { IHeaderData } from 'components/AppTable/AppTable'
import { headerDataFirstValue } from 'components/AppTable/components/headerDataFirstValue'
import { AppTableDndMobile } from 'components/AppTable/AppTableDndMobile'

const headerDataTemperature = [
  {
    title: 'Наименование',
    colWidth: '22%',
    sort: 'name',
    order: 0,
    startPosition: 0,
  },
  { title: 'Станция', colWidth: '10%', order: 1, startPosition: 1 },
  {
    title: 'Категория',
    colWidth: '10%',
    sort: 'categoryName',
    order: 2,
    startPosition: 2,
  },
  { title: 'Дата', colWidth: '5%', order: 3, startPosition: 3 },
  { title: 'Время', colWidth: '10%', order: 4, startPosition: 4 },
  { title: 'Тип замера', colWidth: '8%', order: 5, startPosition: 5 },
  {
    title: 'Эталонная температура продукта мин - макс, °C',
    colWidth: '5%',
    sort: 'standardTempMax',
    order: 6,
    startPosition: 6,
  },
  {
    title: 'Фактическая температура продукта мин - сред- макс, °C',
    colWidth: '15%',
    sort: 'temperatureAvg',
    order: 7,
    startPosition: 7,
  },
  {
    title: 'Соответствие продукта темп режиму ',
    colWidth: '10%',
    order: 8,
    startPosition: 8,
  },
  { title: 'Фото', colWidth: '5%', order: 9, startPosition: 9 },
]

interface IReportFullProps {
  reportData: IBuffetGeneralReportResult[]
  setSearchParams: SetURLSearchParams
  setCurrentSortValue: React.Dispatch<React.SetStateAction<string | null>>
}

export const ReportTemperature = ({
  reportData,
  setSearchParams,
  setCurrentSortValue,
}: IReportFullProps) => {
  const [toggleAllState, setToggleAllState] = useState<number[]>([])
  const { t } = useTranslation()
  const [headerDataDnd, setHeaderData] = useState<IHeaderData[]>(
    headerDataFirstValue(
      'editable-equipment-products-table',
      headerDataTemperature,
    ),
  )
  const subTableRepresentFn = (
    item: IBuffetGeneralReportResult,
    currentCol?: number,
    itemIndex?: number,
    onTouchStart?: ((e: React.TouchEvent) => void) | undefined,
    onTouchMove?: ((e: React.TouchEvent) => void) | undefined,
    width?: number,
    toggleAllState?: number[],
    headerData?: IHeaderData[],
  ) => (
    <SubTableRepresentTemperature
      item={item}
      currentCol={currentCol}
      itemIndex={itemIndex}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      width={width}
      toggleAllState={toggleAllState}
      toggleAllStateFullLenght={reportData.length}
      headerData={headerData}
    />
  )

  return (
    <React.Fragment>
      {reportData && (
        <AppTableDndMobile<
          IBuffetGeneralReportResult,
          keyof IBuffetGeneralReportResult
        >
          toggleAllState={toggleAllState}
          tableName="report-table-temperature"
          setHeaderData={setHeaderData}
          setToggleAllState={setToggleAllState}
          data={{
            count: 0,
            results: reportData,
            previous: '',
            next: '',
          }}
          tableWrapperClassName={'buffet-report-table'}
          tableCellClassName={'buffet-report-page-table-cell'}
          rowClassName={'buffet-report-page-table-category'}
          setCurrentSortFn={setCurrentSortValue}
          tableDataSelectors={[
            {
              renderItem: (item, index) => (
                <div
                  className={
                    index
                      ? 'violet-sticky'
                      : 'buffet-report-page-table-category-title'
                  }
                >
                  {t(item?.name)}
                </div>
              ),
            },
            {
              renderItem: (item) => <div></div>,
            },
            {
              renderItem: (item) => <div>{item?.categoryName}</div>,
            },
            {
              renderItem: () => <div className={`text-end`}>{}</div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div />,
            },
            {
              renderItem: (item) => (
                <>
                  <div className={`text-end`}>
                    {item.standardTempMin}
                    {item.standardTempMin && item.standardTempMax && (
                      <span> - </span>
                    )}
                    {item.standardTempMax}
                  </div>
                </>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {!!(
                    (item.standardTempMin || item.standardTempMin === 0) &&
                    (item.standardTempMax || item.standardTempMax === 0)
                  ) ? (
                    <>
                      <ReportTempView
                        value={item.temperatureMin}
                        min={item.standardTempMin}
                        max={item.standardTempMax}
                      />{' '}
                      {item.temperatureAvg !== null && (
                        <>
                          {'- '}
                          <ReportTempView
                            value={item.temperatureAvg}
                            min={item.standardTempMin}
                            max={item.standardTempMax}
                          />
                        </>
                      )}
                      {item.temperatureMax !== null && (
                        <>
                          {'- '}
                          <ReportTempView
                            value={item.temperatureMax}
                            min={item.standardTempMin}
                            max={item.standardTempMax}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <div>
                      {`${item.temperatureMin
                        .toFixed(2)
                        .toString()
                        .replace(/[.]/g, ',')}-${item.temperatureAvg
                        .toFixed(2)
                        .toString()
                        .replace(/[.]/g, ',')}-${item.temperatureMax
                        .toFixed(2)
                        .toString()
                        .replace(/[.]/g, ',')}`}
                    </div>
                  )}
                </div>
              ),
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  <ImagePreviewWrapper
                    className={'report-image-preview'}
                    onClick={() => {
                      setSearchParams((sp) => {
                        sp.set('report-image-id', item.id.toString())
                        return sp
                      })
                    }}
                    isReportPageItem={true}
                    image={item.imageOnS3 || item.image}
                    size={ImagePreviewWrapperSizeEnum.MEDIUM}
                  />
                </div>
              ),
            },
          ]}
          subTableRepresent={subTableRepresentFn}
          headerData={headerDataDnd}
        />
      )}
    </React.Fragment>
  )
}
